module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fixedholder-gb', [_c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block] + '-overflow'
  }, [_c('transition', {
    attrs: {
      "name": "fixedTransition"
    }
  }, _vm._l((_vm.data.texts), function(text, index) {
    return (index == _vm.sharedData.currentSubSection) ? _c('div', {
      key: text,
      class: [_vm.block] + '-text'
    }, [_c('div', {
      class: [_vm.block] + '-textBlocks'
    }, [_c('div', {
      class: [_vm.block] + '-textBlock',
      domProps: {
        "innerHTML": _vm._s(text.html)
      }
    })])]) : _vm._e()
  }))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aec3b56","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Text.vue
// module id = 449
// module chunks = 0